module.exports = __webpack_public_path__ + "static/media/KREU_110.28eefbf6.png";